import API from '../../../utils/api';

export const getUserId = (data) => {
  if (!data) return null;
  if (data.id) return String(data.id);
  if (data.user?.id) return String(data.user.id);
  return null;
};

export const getTicket = async (isLogged) => {
  if (isLogged) {
    const response = await API.kambyGetTicket();
    return response.data.ticket;
  }
  return '';
};

export const getKambiConfig = async (isLogged ) => {

  if (isLogged) {
    const response = await API.getKambiAuthConfig();
    return response?.data?.config;
  }

  const response = await API.getKambiPublicConfig();
  return response?.data?.config;
};

export const getIsLoggedInKambi = () => {
  return new Promise((resolve, reject) => {
    window?.KambiWidget?.ready?.then(wapi => {
      const mySubscription = wapi.subscribe(async (response, wapi) => {
        switch (response.type) {
          case wapi.USER_SESSION_CHANGE:
            resolve(response.data.isLoggedIn);
            mySubscription.unsubscribe();
            break;
        }
      });

      wapi.request(wapi.USER_SESSION_CHANGE);
    }).catch(reject);
  });
};